export default "__VITE_ASSET__DY9oXLfu__"